import { Component, Input, OnChanges } from '@angular/core';
// Interfaces
import { MenuGroupItem } from '../interfaces';
// Services
import { UiParamsService } from '../services/ui-params.service';

// Helpers

@Component({
	selector    : 'menu-header',
	templateUrl : './header.component.html',
	styleUrls   : ['./header.component.scss']
})
export class HeaderComponent implements OnChanges {

	@Input() public headerStructure : MenuGroupItem[];
	@Input() public mainStructure : MenuGroupItem[];

	public setup_name : string;
	private Nexus = window['Nexus'] ?? {};
	public cta_module_enabled : boolean;

	constructor(public uiParams : UiParamsService)
	{
		this.cta_module_enabled = this.Nexus?.CTA_MODULE_ENABLED === '1';
	}

	ngOnChanges()
	{
		const setup = this.headerStructure.find(group => group.item_name === 'setup');
		if (setup) this.setup_name = setup.name;
	}
}
